"use client";

import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { categoryQueryKeys } from "./category-query-keys";
import {
  getCategoryTree,
  getMainCategoriesWithCounts,
} from "@/app/[locale]/categories/_api/category-reads";
import type {
  CategoryTreeResponse,
  MainCategoriesWithCountsResponse,
} from "@/app/[locale]/categories/_api/category-reads";

/**
 * Hook to fetch the category tree
 */
export function useCategoryTree(
  options?: Omit<UseQueryOptions<CategoryTreeResponse>, "queryKey" | "queryFn">
) {
  return useQuery({
    queryKey: categoryQueryKeys.tree(),
    queryFn: () => getCategoryTree(),
    staleTime: 30 * 60 * 1000, // 30 minutes - categories change rarely
    ...options,
  });
}

/**
 * Hook to fetch main categories with shop counts
 */
export function useMainCategoriesWithCounts(
  options?: Omit<UseQueryOptions<MainCategoriesWithCountsResponse>, "queryKey" | "queryFn">
) {
  return useQuery({
    queryKey: categoryQueryKeys.mainWithCounts(),
    queryFn: () => getMainCategoriesWithCounts(),
    staleTime: 30 * 60 * 1000, // 30 minutes - categories change rarely
    ...options,
  });
}